import React from 'react'

export default function Column({children,style={}}) {
    return (
        <div className='d-flex flex-column' style={style}>
            {children}
        </div>
    )
}
